import React
from "react";


export default function InsightDashboardPriorityBubbles({
    data = [],
    clickFunction
})
{

    //--------------------------------------------------------
    // Get priority
    //--------------------------------------------------------

    function getPriority(name)
    {
        const value =
            (name || "")
                .trim()
                .toUpperCase();


        if(
            value === ""
            ||
            value === "NONE"
            ||
            value === "UNKNOWN"
            ||
            value === "NOT SET"
        )
        {
            return {
                order: 0,
                label: "None",
                colour: "#9ca3af",
                glow: "rgba(156,163,175,0.25)"
            };
        }


        if(value.includes("LOW"))
        {
            return {
                order: 1,
                label: "Low",
                colour: "#38b878",
                glow: "rgba(56,184,120,0.28)"
            };
        }


        if(value.includes("MEDIUM"))
        {
            return {
                order: 2,
                label: "Medium",
                colour: "#f4b73f",
                glow: "rgba(244,183,63,0.30)"
            };
        }


        if(
            value.includes("HIGH")
            ||
            value.includes("CRITICAL")
        )
        {
            return {
                order: 3,
                label: "High",
                colour: "#e84d4f",
                glow: "rgba(232,77,79,0.30)"
            };
        }


        return {
            order: 0,
            label: name || "None",
            colour: "#9ca3af",
            glow: "rgba(156,163,175,0.25)"
        };
    }


    //--------------------------------------------------------
    // Map data
    //--------------------------------------------------------

    const mappedData =
        (data || [])
            .map(
                (item) =>
                {
                    const priority =
                        getPriority(
                            item.name
                        );


                    return {
                        ...item,

                        displayLabel:
                            priority.label,

                        colour:
                            priority.colour,

                        glow:
                            priority.glow,

                        order:
                            priority.order
                    };
                }
            )
            .sort(
                (a, b) =>
                    a.order - b.order
            );


    //--------------------------------------------------------
    // Maximum
    //--------------------------------------------------------

    const maximum =
        mappedData.reduce(
            (max, item) =>
            {
                return Math.max(
                    max,
                    item.total || 0
                );
            },
            0
        );


    //--------------------------------------------------------
    // Bubble size
    //--------------------------------------------------------

    function getBubbleSize(value)
    {
        const minimumSize =
            52;

        const maximumSize =
            92;


        if(maximum <= 0)
        {
            return minimumSize;
        }


        /*
         * Square root scaling stops the largest
         * value completely dominating the panel.
         */

        const ratio =
            Math.sqrt(
                (value || 0)
                /
                maximum
            );


        return (
            minimumSize
            +
            (
                (
                    maximumSize
                    -
                    minimumSize
                )
                *
                ratio
            )
        );
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={containerStyle}>

            {
                mappedData.map(
                    (item, index) =>
                    {

                        const bubbleSize =
                            getBubbleSize(
                                item.total
                            );


                        return (

                            <div
                                key={
                                    (
                                        item.name
                                        ||
                                        "priority"
                                    )
                                    +
                                    "-"
                                    +
                                    index
                                }

                                style={itemStyle}

                                onClick={() =>
                                {
                                    if(clickFunction)
                                    {
                                        clickFunction(
                                            item
                                        );
                                    }
                                }}
                            >

                                <div
                                    style={{
                                        ...bubbleStyle,

                                        width:
                                            bubbleSize
                                            +
                                            "px",

                                        height:
                                            bubbleSize
                                            +
                                            "px",

                                        background:
                                            "radial-gradient("
                                            +
                                            "circle at 35% 30%, "
                                            +
                                            "rgba(255,255,255,0.28) 0%, "
                                            +
                                            item.colour
                                            +
                                            " 38%, "
                                            +
                                            item.colour
                                            +
                                            " 100%"
                                            +
                                            ")",

                                        boxShadow:
                                            "0 10px 24px "
                                            +
                                            item.glow
                                            +
                                            ", "
                                            +
                                            "inset 0 1px 1px "
                                            +
                                            "rgba(255,255,255,0.32)"
                                    }}
                                >

                                    <div style={valueStyle}>
                                        {
                                            (
                                                item.total
                                                ||
                                                0
                                            ).toLocaleString()
                                        }
                                    </div>

                                </div>


                                <div style={labelStyle}>
                                    {item.displayLabel}
                                </div>

                            </div>

                        );
                    }
                )
            }

        </div>

    );
}


//--------------------------------------------------------
// Styles
//--------------------------------------------------------

const containerStyle =
{
    width: "100%",
    height: "100%",

    minWidth: 0,
    minHeight: 0,

    display: "flex",

    alignItems: "center",
    justifyContent: "space-evenly",

    gap: "10px",

    padding: "4px 8px"
};


const itemStyle =
{
    flex: "1 1 0",

    minWidth: 0,

    display: "flex",
    flexDirection: "column",

    alignItems: "center",
    justifyContent: "center",

    cursor: "pointer"
};


const bubbleStyle =
{
    flexShrink: 0,

    display: "flex",

    alignItems: "center",
    justifyContent: "center",

    border:
        "1px solid rgba(255,255,255,0.45)",

    borderRadius: "50%",

    transition:
        "transform 0.18s ease"
};


const valueStyle =
{
    color: "#ffffff",

    fontSize: "16px",
    lineHeight: "1",

    fontWeight: "800",

    textShadow:
        "0 2px 5px rgba(0,0,0,0.20)"
};


const labelStyle =
{
    marginTop: "8px",

    color: "#687483",

    fontSize: "8px",
    fontWeight: "700",

    letterSpacing: "0.7px",

    textTransform: "uppercase",

    whiteSpace: "nowrap"
};